// frontend/src/features/livestock/PhotosToSortRow.tsx
import { Group, Text, UnstyledButton } from '@mantine/core';
import { IconChevronRight, IconPhoto } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import classes from './PhotosToSortRow.module.css';

export interface PhotosToSortRowProps {
  count: number;
}

/** Under the Livestock header while the tank's inbox has photos (plan 4.2): one link, row high. */
export function PhotosToSortRow({ count }: PhotosToSortRowProps): JSX.Element {
  return (
    <UnstyledButton component={Link} to="/livestock/photos" className={classes.row}>
      <Group gap="xs" wrap="nowrap">
        <IconPhoto size={16} color="var(--mantine-color-teal-6)" style={{ flexShrink: 0 }} />
        <Text size="sm" fw={500} className={classes.count}>
          {`${count} ${count === 1 ? 'photo' : 'photos'} to sort`}
        </Text>
        <Text size="sm" fw={500} c="var(--rdh-brand-on-light)" ml="auto">
          Sort
        </Text>
        <IconChevronRight size={16} color="var(--rdh-brand-on-light)" style={{ flexShrink: 0 }} />
      </Group>
    </UnstyledButton>
  );
}
